import { render, staticRenderFns } from "./AddAssetDialog.vue?vue&type=template&id=bbbd1f40&scoped=true&"
import script from "./AddAssetDialog.vue?vue&type=script&lang=js&"
export * from "./AddAssetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbd1f40",
  null
  
)

export default component.exports